// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

const domain = 'test1-0ae56.hq.spicaengine.com';

export const environment = {
  production: false,
  domain,
  url: `https://${domain}/api`,
  ws_url: `wss://${domain}/api`,
  buckets: {
    locations: '5f203c80ab89fd0e33e79bfb', //employees in spica DB
    eventType: '5f203e1dab89fd4a59e79c0c', //services in spica DB
    bookings: '5f203dd5ab89fd736fe79c07', //schedules in spica DB
    company: '5f203de7ab89fd344fe79c09',
    tokens: '5f29794dd170253fd02df632',
    subscriptions: '5f33a9e6294d54512230dbc3',
    users: '5f72ef0535a292b1cddce402',
    customer_tokens: '5f732e9535a292695adce481',
    register_tokens: '621f754187b6cb002d2e6596',
    customers: '5f33aa3f294d54b37530dbc5',
    mailing_list: '624c514987b6cb002d2e7c5e',
    events: '624d2f6a87b6cb002d2e7c79',
    settings: '5f53a62b22e1592d0fbec0fa',
    wizard_questions: '62bc6b4e3d3270002cd7e23f',
    // working_hours: '5f203ce2ab89fd05b3e79c01',
    // countries: '5f203ca5ab89fd658ee79bfe',
    // vacations: '5f35003c294d5482a730dc64',
    // service_groups: '5f339cd7294d540d0730dbb6',
    // targets: '5f339f4e294d54102e30dbb9',
    // prices: '5f229916d17025f3e12df4fa',
    // ressource_groups: '611cdc72c1ef6fd9f5c7e08d',
    // schedule_states: '6123837bc1ef6fa5acc7e7aa',
    // mottos: '613764ff4d4e07002cdbddb3',
  },
  apikey: '3irnu18l7lx75h2',
  app_version: '0.3.5',

  //TODO: hier kommen alle StorageKeys hinein
  storage: {
    company: "company_event",
    tags: "tags_event",
    language: "language_event",
    progress: "progress_event",
    viewdate: "viewdate_event",
    services: "services_event",
    allSchedules: "allSchedules_event",
    eventtype: "eventtype_event",
    maillinglist: "maillinglist_event",
    locations: "locations_event",
    allEmployees: "allEmployees_event",
    allEmployeesWithRelation: "allEmployeesWithrelation_event",
    serviceIFrame: "serviceIFrame_event"


  },
  companyCategory: "624c51cf87b6cb002d2e7c63"  // Event
};

//Google api
export const CLIENT_ID = '489474746701-ffmpjpon36b15a7sv0j3msalkc4hdlk8.apps.googleusercontent.com';
// export const CLIENT_SECRET = "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";


/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
